module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    staticClass: "leaseSentDetail",
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.DataDetail]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货通知单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "Partner.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户订单号",
      "prop": "Partner.Code"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticClass: "table-shin-expand",
    attrs: {
      "data": _vm.ProductLines,
      "element-loading-text": "加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row), function(Product) {
          return _c('div', {
            key: Product.Id,
            staticClass: "inner-list"
          }, [_c('div', {
            staticClass: "list-item",
            staticStyle: {
              "min-width": "160px"
            }
          }, [_c('label', [_vm._v("物料名称/编码")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Product.Product.Name))]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("物料编码：" + _vm._s(Product.Product.Code))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item",
            staticStyle: {
              "min-width": "160px"
            }
          }, [_c('label', [_vm._v("客户物料名称/编码")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("百叶窗防窥罩1 ")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("物料编码：004DZ2831GZ")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item",
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('span', {
            staticClass: "el-tag el-tag--primary",
            staticStyle: {
              "margin-top": "8px"
            }
          }, [_vm._v(_vm._s(Product.Condition.Name))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("品牌：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Product.Product.Brand.Name))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("机型：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Product.Product.Model.Name))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("模块：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Product.Product.Module.Name))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("数量：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Product.Quantity))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("库存来源：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(_vm._f("inventorySource")(Product.Type)))])])])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row[0].ContactName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "min-width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row[0].ContactPhone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送地址",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row[0].Address))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流类型",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("ShipmentMethod")(props.row[0].ShipmentMethod)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送类型",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("ChangeDeliveryType")(props.row[0].DeliveryType)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约时间",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row[0].CreationTime, 'YYYY/MM/DD')))]
      }
    }])
  }), _vm._v(" "), (_vm.Detail.State === 'finished') ? [_c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "min-width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流费用",
      "min-width": "120px"
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0aa8de4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Order/LeaseSentDetail_order.vue
// module id = 764
// module chunks = 0